import React, { useState } from 'react'
import { Modal, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import 'moment-timezone'
import { Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { errorUpdate } from '../actions/user'

const Error = ({ open, message, setOpen }) => {
    const user = useSelector((state) => state.user)
    const dispatch = new useDispatch()

    //***********MODAL******************* */

    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    return (
        <Modal
            open={user.errorStatus}
            onClose={() => dispatch(errorUpdate(false, ''))}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styleDeletePopup} className="deletePopup">
                <div className="iconshadow">
                    <i className=" deleteIconPopup">
                        <button>
                            <img src={require('../assets/images/Group 427319173.png')} />
                        </button>
                    </i>
                </div>
                <div className="textDeletePopup">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Error
                    </Typography>
                    <Typography
                        style={{ fontSize: '18px' }}
                        id="modal-modal-description"
                        sx={{ mt: 2 }}
                    >
                        {user.errorMessage}
                    </Typography>

                    <Typography>
                        <div className="buttonGroupDelete">
                            <button
                                className="btn btn-primary btn-block deleteButtonUser"
                                onClick={() => dispatch(errorUpdate(false, ''))}
                            >
                                Try again
                            </button>
                        </div>
                    </Typography>
                </div>
            </Box>
        </Modal>
    )
}

export default Error
